import ServerLoggerService from './ServerLoggerService'
export default new ServerLoggerService()
